import { SLA_CONSTANTS } from './constants'
import {AuthConstants} from "../auth/constants";

export function slas(state = {}, action) {
  switch (action.type) {
    case SLA_CONSTANTS.GET_SLAS_REQUEST:
      return {
        ...state,
      }
    case SLA_CONSTANTS.GET_SLAS_SUCCESS: {
      return {
        ...state,
        ...action.response,
      }
    }
    case SLA_CONSTANTS.GET_SLAS_FAILURE: {
      return {
        ...state,
        ...action.response,
      }
    }
     case AuthConstants.DELETE_AUTH_INFO: {
      return {}
    }

    default:
      return state
  }
}
